import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { CtaButtonComponent } from '../../../../shared/components/ui/cta-button/cta-button.component';
import { InputFieldComponent } from '../../../../shared/components/ui/input-field/input-field.component';
import { AuthForm } from '../../../auth/types/auth-form.type';

@Component({
  selector: 'app-patrol-signin-form',
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    ReactiveFormsModule,
    InputFieldComponent,
    CtaButtonComponent,
  ],
  templateUrl: './patrol-signin-form.component.html',
  styleUrl: './patrol-signin-form.component.scss',
})
export class PatrolSigninFormComponent {
  requestPending = input(false);
  formSubmitted = output<AuthForm>();

  signinForm!: FormGroup<AuthForm>;

  constructor(private fb: FormBuilder) {
    this.signinForm = this.fb.group<AuthForm>({
      userName: this.fb.control('', {
        validators: [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9._]+$/),
        ],
        nonNullable: true,
      }),
      password: this.fb.control('', {
        validators: [Validators.required],
        nonNullable: true,
      }),
    });
  }

  onSubmit(): void {
    const raw = this.signinForm.getRawValue();
    const trimmedUserName = raw.userName.trim();
    this.signinForm.patchValue({ userName: trimmedUserName });
    this.signinForm.controls.userName.updateValueAndValidity();
    if (this.signinForm.valid) {
      this.formSubmitted.emit(this.signinForm.getRawValue());
    }
  }
}
